//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('checkPointHeads', {
//        templateUrl: 'views/components/views/checkPointHeads/checkPointHeads.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'checkPointHeadsService', function ($stateParams, checkPointHeadsService) {
//            const vm = this;
//            let argType = $stateParams.argtype;
//            let argValue = $stateParams.argvalue;

//            vm.model = {
//                itemsListCheckPoints: []
//            };

//            async function loadCheckPoints() {
//                vm.model.itemsListCheckPoints = await checkPointHeadsService.listCheckPoints({
//                    argtype: argType,
//                    argvalue: argValue
//                });
//            }

//            vm.$onInit = async function () {
//                loadCheckPoints();
//            }
//        }]
//    });
//})();
